import { v1Url } from '@/utils/fetcher';
import { useAxios } from '../base/useAxios';
import { useRealTimeUpdates } from '../base/useRealTimeUpdates';

const defaultParams = {
  pageSize: 1,
  orderBy: 'date',
  sortOrder: 'desc',
};

const normalize = ({ data }) => data;

export default function useCommentActions() {
  const api = useAxios();

  const { emit: emitRealTimeUpdate, socketId } = useRealTimeUpdates();

  function config() {
    return {
      headers: {
        'Socket-ID': socketId.value,
        'Triggered-By': 'user',
        'Sent-By': 'composable',
      },
    };
  }

  return {
    fetchByType({ id, type, params, pagination }) {
      const promise = api.put(
        v1Url(`${type}/${id}/comments`),
        { ...defaultParams, ...params, ...pagination },
        normalize,
      );
      return promise;
    },

    markCommentAsRead({ id, itemType, item, params, pagination }) {
      const promise = api
        .put(v1Url(`comments/${id}/markread`), { ...defaultParams, ...params, ...pagination }, config())
        .then(() =>
          emitRealTimeUpdate({
            type: 'comment',
            action: 'markread',
            detail: `${itemType}_comment-markread`,
            commentId: Number(id),
            projectId: item.projectId || null,
            taskListId: item.tasklistId || null,
            taskId: itemType === 'task' ? item.id : undefined,
            parentTaskId: itemType === 'task' ? item.parentTaskId : undefined,
            socketId: socketId.value,
          }),
        );
      return promise;
    },
  };
}
